import React from 'react';

const ViewFormModal = ({ contact, onClose }) => {
  if (!contact) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-lg w-full max-h-[80vh] flex flex-col">
        <h2 className="text-2xl font-bold text-[#364A9A] mb-6 font-poppins">Form Details</h2>
        <div className="space-y-4 overflow-y-auto">
          <div>
            <p className="font-bold">Name:</p>
            <p>{contact.name}</p>
          </div>
          <div>
            <p className="font-bold">Email:</p>
            <p>{contact.email}</p>
          </div>
          <div>
            <p className="font-bold">Telephone:</p>
            <p>{contact.telephone}</p>
          </div>
          <div>
            <p className="font-bold">Message:</p>
            <p className="whitespace-pre-wrap">{contact.message}</p>
          </div>
          <div>
            <p className="font-bold">Submitted At:</p>
            <p>{new Date(contact.createdAt).toLocaleString()}</p>
          </div>
        </div>
        <div className="text-right mt-6">
          <button
            onClick={onClose}
            className="bg-gray-500 text-white font-bold py-2 px-4 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out transform hover:scale-105 font-poppins"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewFormModal;
